import {FilterProviderPipe, FilterTemplatePipe,
  FilterTemplateListPipe, ArraySortFiledPipe, FilterClientPipe, FilterPipe, FilterLblCartPipe, ArraySortNumberPipe, ArraySortPipe} from './helperfilter.pipe';
import { NgModule } from '@angular/core';
import { TransformarTextoPipe } from 'app/transformar-texto.pipe';

@NgModule({
  imports: [
    // dep modules
  ],
  declarations: [
    FilterProviderPipe,
    FilterTemplatePipe,
    FilterTemplateListPipe,
    FilterClientPipe,
    FilterPipe,
    FilterLblCartPipe,
    ArraySortFiledPipe,
    ArraySortNumberPipe,
    ArraySortPipe,
    TransformarTextoPipe
  ],
  exports: [
    FilterProviderPipe,
    FilterTemplatePipe,
    FilterTemplateListPipe,
    FilterClientPipe,
    FilterPipe,
    FilterLblCartPipe,
    ArraySortFiledPipe,
    ArraySortNumberPipe,
    ArraySortPipe,
    TransformarTextoPipe
  ]
})
export class ApplicationPipesModule {}
